import { render } from "./Image.vue?vue&type=template&id=25a26944"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__